module.exports = __webpack_public_path__ + "static/aopsafaritowel-60495cbdaa54c51fb54148acb018968c.jpeg";